<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div class="headerImageHeight" style="background-size: cover; background-position:center;"
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'header-image.png)'}">
        <div class="row">
            <div style="width:10%"></div>
            <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''" class="text-center whiteText" style="width:80%">
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">GOLF
                </h1>
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">YOUR
                    PARTNER IN GROWING <br>EXCEPTIONAL GOLF COURSES</h1>
            </div>
            <div style="width:10%"></div>
        </div>
        <!-- <div class="row"
            *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
            <div style="width:22%"></div>
            <div class="text-center whiteText" style="width:56%">
                <h2 class="DIN2014Regular whiteText" style="font-size:19px;line-height:30px;letter-spacing: .38px;">
                    Discover Top Products and Services from Leading Providers.</h2>
            </div>
            <div style="width:22%"></div>
        </div>
        <div class="row text-center"
            *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
            style="padding-top:3%; padding-bottom:3%">
            <h3><a class="DIN2014Bold greenBackground whiteText"
                    style="font-size:20px;font-weight:700;padding:8pt; text-decoration: none !important"
                    href='/findrep'>FIND YOUR REP</a>
            </h3>
        </div> -->
    </div>
    <div class="row whiteBackground">
        <div class="col-md-2"></div>
        <div class="col-md-8 text-center" style="padding-top:70px; padding-bottom:70px">
            <h3 class="DIN2014Regular blackText harrellsProvides">
                At Harrell’s, we know that maintaining championship-level playing conditions requires precision,
                expertise, and the right agronomic solutions. That’s why golf course superintendents nationwide trust
                our premium fertilizers, plant protection products, and soil health solutions to keep their courses in
                peak condition. <br> <br> With industry-leading innovations like POLYON® controlled-release fertilizer and expert
                guidance from our dedicated sales and technical teams, we help you achieve consistent turf performance,
                strong root development, and superior playability. Whether you're preparing for daily rounds or major
                tournaments, Harrell’s is your partner in growing healthier, more resilient golf course turf.</h3>
        </div>
        <div class="col-md-2"></div>
    </div>
    <!-- <div class="row">
        <div class="col-lg-6 greenText lightCremeBackground"
            style="padding-right:0px; padding-left:0px; padding-top:70px">
            <h3 class="Caecilia76BoldItalic becomeAHarrells">
                Become A Harrell's Customer<br>Here's How It Works</h3>
            <div class="d-flex justify-content-end">
                <img style="width:10vw; margin-right:5%; margin-top:15px" src="{{this.baseImagePaths + 'dots.png'}}"
                    alt="market dots image">
            </div>
        </div>
        <div class="col-lg-6 blueText lightCremeBackground threeDots">
            <h3 class="DIN2014Bold" style="font-size:26px;line-height:26px"><span
                    style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                    class="DINNextLTPro-Black blueBackground whiteText">1</span>&nbsp;&nbsp;&nbsp;Create An Account</h3>
            <h3 class="DIN2014Bold" style="font-size:26px; margin-top:3%"><span
                    style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                    class="DINNextLTPro-Black blueBackground whiteText">2</span>&nbsp;&nbsp;&nbsp;Place Your Order</h3>
            <h3 class="DIN2014Bold" style="font-size:26px; margin-top:3%"><span
                    style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                    class="DINNextLTPro-Black blueBackground whiteText">3</span>&nbsp;&nbsp;&nbsp;Get Support </h3>
            <h3 style="margin-top:50px"><a class="DIN2014Bold greenBackground whiteText"
                    style="font-size:20px;padding:8px; text-decoration: none !important" href='/findrep'>LET'S
                    GROW</a></h3>
        </div>
    </div> -->


    <div class="row cremeBackground text-center whiteText" style="margin: auto; padding-top:70px">
        <div class="text-center p-0" style="margin-top:10px; margin-bottom:10px">
            <div style="display:inline-block; position:relative; top:38px">
                <img class="topFourImages" style="object-fit: cover; object-position:center;"
                    src="{{this.pageImagePaths + 'golf1.jpg'}}" alt="POLYON & Custom-Blended Fertilizer">
                <h4 class="DIN2014Regular whiteText topFourImagesTextThreeRows">
                    POLYON &</h4>
                <h4 class="DIN2014Regular whiteText topFourImagesTextThreeRows">
                    CUSTOM-BLENDED</h4>
                <h4 class="DIN2014Regular whiteText topFourImagesTextThreeRows">
                    FERTILIZER</h4>
            </div>
            <div style="display:inline-block; position:relative; top:38px">
                <img class="topFourImages" style="object-fit: cover; object-fit:center;"
                    src="{{this.pageImagePaths + 'golf2.jpg'}}" alt="Liquid Nutrition & Proprietary Products">
                <h4 class="DIN2014Regular whiteText topFourImagesTextThreeRows">
                    LIQUID NUTRITION</h4>
                <h4 class="DIN2014Regular whiteText topFourImagesTextThreeRows">
                    & PROPRIETARY</h4>
                <h4 class="DIN2014Regular whiteText topFourImagesTextThreeRows">
                    PRODUCTS</h4>
            </div>
            <div style="display:inline-block">
                <img class="topFourImages" style="object-fit: cover; object-fit:center;"
                    src="{{this.pageImagePaths + 'golf3.jpg'}}" alt="Trusted Chemistry">
                <h4 class="DIN2014Regular whiteText topFourImagesText">
                    TRUSTED</h4>
                <h4 class="DIN2014Regular whiteText topFourImagesText">
                    CHEMISTRY</h4>
            </div>
            <div style="display:inline-block">
                <img class="topFourImages" style="object-fit: cover; object-fit:center;"
                    src="{{this.pageImagePaths + 'golf4.jpg'}}" alt="Premium Golf Seed">
                <h4 class="DIN2014Regular whiteText topFourImagesText">
                    PREMIUM</h4>
                <h4 class="DIN2014Regular whiteText topFourImagesText">
                    GOLF SEED</h4>
            </div>
            <div style="display:inline-block">
                <img class="topFourImages" style="object-fit: cover; object-fit:center;"
                    src="{{this.pageImagePaths + 'golf5.jpg'}}" alt="Plant Health Inputs">
                <h4 class="DIN2014Regular whiteText topFourImagesText">
                    PLANT HEALTH</h4>
                <h4 class="DIN2014Regular whiteText topFourImagesText">
                    INPUTS</h4>
            </div>
        </div>
    </div>

    
    <div class="row whiteBackground">
        <div class="col-md-2"></div>
        <div class="col-md-8 text-center" style="padding-top:70px;">
            <h3 class="DIN2014Bold blueText iCannotSayEnough">
                "I’ve used different fertility and fungicide programs throughout my career, but the one constant regarding applications has been my Harrell's Rep. He and I have built this thing every year, and I know that I wouldn’t be as successful without his advice and counsel through the years."</h3>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2"></div>
        <div class="col-md-8 text-center" style="padding-bottom:70px; margin-top:60px">
            <h3 class="Caecilia76BoldItalic greenText" style="font-size: 20px; letter-spacing: .48px;">
                -Chad Mark, Golf Course Superintendent, Muirfield Village</h3>
        </div>
        <div class="col-md-2"></div>
    </div>

    <app-customerform></app-customerform>

    <div class="lightCremeBackground">
        <div class="row lightCremeBackground yourPartnerForSuccess" id="partnersSuccessBlock">
            <div class="col-lg-4 greenText lightCremeBackground" style="padding-right:0px; padding-left:0px">
                <h3 class="Caecilia76BoldItalic yourPartnerForSuccessDetail">
                    Harrell's Is Your<br />Partner For Success</h3>
            </div>
            <div class="col-lg-8">
                <div class="row lightCremeBackground" style="padding-right:10%;">
                    <div class="col-lg-4 blueText text-center yourPartnerForSuccessBorder">
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.pageImagePaths + 'icon-1.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText pb-5"
                                style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                PH.D'S INNOVATING
                                <br>
                                PRODUCTS AND
                                <br>
                                PROGRAMS
                            </h4>
                        </div>
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.pageImagePaths + 'icon-4.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                INVENTORY ENSURING <BR> PRODUCTS STAY <BR> STOCKED
                            </h4>
                        </div>
                    </div>
                    <div class="col-lg-4 blueText text-center" style="padding-left:20px">
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.pageImagePaths + 'icon-2.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText pb-5"
                                style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                REPS WITH <BR> FIRST-HAND FIELD <BR> EXPERIENCE
                            </h4>
                        </div>
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.pageImagePaths + 'icon-5.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                OPS & DRIVERS <BR> DELIVERING THE <BR> GOODS
                            </h4>
                        </div>
                    </div>
                    <div class="col-lg-4 blueText text-center" style="padding-left:20px">
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.pageImagePaths + 'icon-3.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText pb-5"
                                style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                IT PROVIDING <BR> PROPRIETARY <BR> TECH
                            </h4>
                        </div>
                        <div class="margin:10px;">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.pageImagePaths + 'icon-6.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                CORPORATE TEAMS <BR> SUPPORTING <BR> IT ALL
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="row whiteBackground"
        *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
        style="padding-top:70px; padding-bottom:70px;text-align: center; padding-left:20px">
        <div class="row justify-content-lg-center">
            <div class="row text-align-start" style="width:1000px; text-align: left;padding-bottom:20px">
                <h3 class="Caecilia76BoldItalic greenText"
                    style="width:70%; display:inline; font-size:28px; margin-bottom:1.5%; ">
                    Trusted Products For Course Growth</h3>
                <a href="/products" style="width:30%; float:right;display:inline;">
                    <h3 class="DIN2014 blackText"
                        style="float:right;display:inline; font-size:16px; font-weight: 700; margin-top:10px; text-decoration: underline; ">
                        VIEW ALL PRODUCTS</h3>
                </a>
            </div>

            <div class="row whiteBackground  justify-content-lg-center" style="padding-left:20px">
                <img *ngIf="featuredProducts.length>4" style="margin-top:5%; width:65px; height:50px; "
                    (click)="this.PreviousFeaturedProduct()" src="{{this.pageImagePaths + 'left-arrow.jpg'}}"
                    alt="left arrow">
                <div *ngIf="this.featuredProduct1ItemNmbr != ''" style="width:235px; margin-right:20px">
                    <div (click)="this.ViewRelatedProductDetail(this.featuredProduct1ItemNmbr)"
                        style="text-align: left">
                        <img style="width:236px; height:235px;"
                            src="{{productImagePaths + this.featuredProduct1ItemNmbr + '.jpg'}}" alt="fertilizer image">
                        <h5 class="DIN2014Regular"
                            style="margin-top:10px;font-size:16px; line-height: 19px; letter-spacing: .32px; text-transform: capitalize;">
                            {{this.featuredProduct1ProductName | uppercase}}</h5>

                        <button class="DIN2014Regular greenBackground whiteText"
                            style="border:none; margin-top:10px; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">MORE</button>
                    </div>
                </div>
                <div *ngIf="this.featuredProduct2ItemNmbr != ''" style="width:235px; height:235px; margin-right:20px">

                    <div (click)="this.ViewRelatedProductDetail(this.featuredProduct2ItemNmbr)"
                        style="text-align: left">
                
                        <img style="width:235px; height:235px;"
                            src="{{productImagePaths + this.featuredProduct2ItemNmbr + '.jpg'}}" alt="fertilizer image">
                        <h5 class="DIN2014Regular"
                            style="margin-top:10px;font-size:16px; line-height: 19px; letter-spacing: .32px; text-transform: capitalize;">
                            {{this.featuredProduct2ProductName | uppercase}}</h5>
                     
                        <button class="DIN2014Regular greenBackground whiteText"
                            style="border:none;margin-top:10px; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">MORE</button>
                    </div>
                </div>
                <div *ngIf="this.featuredProduct3ItemNmbr != ''" style="width:235px; height:235px; margin-right:20px">
                    <div (click)="this.ViewRelatedProductDetail(this.featuredProduct3ItemNmbr)"
                        style="text-align: left">
                        <img style="width:235px; height:235px;"
                            src="{{productImagePaths + this.featuredProduct3ItemNmbr + '.jpg'}}" alt="fertilizer image">
                        <h5 class="DIN2014Regular"
                            style="margin-top:10px;font-size:16px; line-height: 19px; letter-spacing: .32px; text-transform: capitalize;">
                            {{this.featuredProduct3ProductName | uppercase}}</h5>
            
                        <button class="DIN2014Regular greenBackground whiteText"
                            style="border:none; margin-top:10px;  margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">MORE</button>
                    </div>
                </div>
                <div *ngIf="this.featuredProduct4ItemNmbr != ''" style="width:235px; height:235px;">
                    <div (click)="this.ViewRelatedProductDetail(this.featuredProduct4ItemNmbr)"
                        style="text-align: left">
                        <img style="width:235px; height:235px;"
                            src="{{productImagePaths + this.featuredProduct4ItemNmbr + '.jpg'}}" alt="fertilizer image">
                        <h5 class="DIN2014Regular"
                            style="margin-top:10px; font-size:16px; line-height: 19px; letter-spacing: .32px; text-transform: capitalize;">
                            {{this.featuredProduct4ProductName | uppercase}}</h5>
        
                        <button class="DIN2014Regular greenBackground whiteText"
                            style="border:none;margin-top:10px; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">MORE</button>
                    </div>
                </div>
                <img *ngIf="featuredProducts.length>4" style="margin-top:5%; width:65px; height:50px; margin-left:20px"
                    (click)="this.NextFeaturedProduct()" src="{{this.pageImagePaths + 'right-arrow.jpg'}}"
                    alt="right arrow">
            </div>
        </div>
    </div> -->


    <!-- <div class="row text-center" style="background-size: cover; background-position:center; padding-bottom:5%"
        [ngStyle]="{backgroundImage: 'url(' + this.baseImagePaths + 'harrells-pattern-full.png)'}">
        <h3 class="DINNextLTPro-Black whiteText"
            style="font-size:30px; line-height:44px; text-transform: uppercase; text-align: center; margin-top:5%">
            Harrell’s is the exclusive United States owner,<br> formulator and distributor of POLYON® <br>controlled
            release
            fertilizer.</h3>
        <h3 style="margin-top:3%"><a class="DIN2014Bold whiteBackground greenText"
                style="font-size:20px ;padding:8pt; text-decoration: none !important" href='/findrep'>CONNECT WITH
                YOUR
                REP</a>
        </h3>
    </div> -->
    <!-- <div class="row blackText text-center"
        style="padding-top:70px;padding-bottom:70px; max-width: 1200px; margin: auto;">
        <div class="col-2"></div>
        <div class="col-lg-4 greenText  balancedApproachOuter">
            <h4 class="Caecilia76BoldItalic balancedApproachTitle">
                Take a Balanced<br>Approach to<br>Growth</h4>
            <h6 class="DIN2014Regular blackText balancedApproachDetail">
                Harrell's Balanced Approach is a scientifically supported, integrated, and proactive use of agronomic
                resources to maximize plant health and consistency.</h6>
        </div>
        <div class="col-4">
            <div class="row balancedApproachImages">
                <div class="col-lg-6" style="padding-top:10%">
                    <div style="margin:auto;height:50px; width:50px;"><img style="margin-top:8px; width:50px"
                            src="{{this.pageImagePaths + 'soil-icon.png'}}" alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px">SOIL</h4>
                    <div style="margin:auto;height:50px; width:50px; padding-top:30px"><img
                            style="margin-top:8px; width:50px" src="{{this.pageImagePaths + 'water-icon.png'}}"
                            alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; padding-top:30px">WATER</h4>
                </div>
                <div class="col-lg-6" style="padding-top:10%">
                    <div style="margin:auto;height:50px; width:50px;"><img style="margin-top:8px; width:50px"
                            src="{{this.pageImagePaths + 'nutrition-icon.png'}}" alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px">NUTRITION</h4>
                    <div style="margin:auto;height:50px; width:50px; padding-top:30px"><img
                            style="margin-top:8px; width:50px" src="{{this.pageImagePaths + 'protection-icon.png'}}"
                            alt="soilIcon"></div>
                    <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; padding-top:30px">PROTECTION
                    </h4>
                </div>
            </div>
        </div>
        <div class="col-2"></div>
    </div> -->
    <!-- <div class="row">
        <div class="col-9 blueBackground whiteText" style="padding-top:5%">
            <h4 class="DIN2014Bold" style="text-align: LEFT; margin-left:20%; font-size:36px; line-height: 46px;">
                Don't grow it alone. Connect with Harrell's to harness the power of research, science, and support in
                ways you never thought possible.</h4>
        </div>
        <div class="col-3 blueBackground whiteText" style="padding-top:3%">
        </div>
    </div> -->
    <!-- <div class="row blueBackground" style="padding-bottom:5%">
        <div class="col-xs-12 col-md-9" style="padding-top:3%">
            <h3 style="margin-left:20%"><a class="DIN2014Bold whiteBackground greenText"
                    style="font-size:20PX ;padding:8pt; text-decoration: none !important" href='/findrep'>CONNECT WITH
                    YOUR REP</a>
            </h3>
        </div>
    </div> -->
    <div class="row">
        <div class="col-12 whiteBackground greenText" style="padding-top:5%">
            <h4 class="Caecilia76BoldItalic" style="text-align: center; font-size:28px; line-height: 46px;">
                Products You Can Count On From Leading Manufacturers</h4>
        </div>
    </div>
    <div class="row pb-5">
        <div class="col text-center">
            <img style="margin-top:45px; height:40px;"
                src="{{this.pageImagePaths + 'logo-2-fpo.jpg'}}" alt="Polyon fpo image">
        </div>
        <div class="col text-center">
            <img style="margin-top:6%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-3-fpo.png'}}" alt="Envu fpo image">
        </div>
        <div class="col text-center">
            <img style="margin-top:6%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-6-fpo.png'}}" alt="Syngenta fpo image">
        </div>
        <div class="col text-center">
            <img style="margin-top:18%; height:40px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-4-fpo.png'}}" alt="BASF fpo image">
        </div>
        <div class="col text-center">
            <img style="margin-top:5%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-5-fpo.png'}}" alt="Envu fpo image">
        </div>
        <div class="col text-center">
            <img style="margin-top:5%; height:110px; padding-bottom:6px"
                src="{{this.pageImagePaths + 'logo-1-fpo.png'}}" alt="HarrelsMax fpo image">
        </div>
    </div>

    <app-blogsbymarketpage></app-blogsbymarketpage>

    <app-toolsforthetrade></app-toolsforthetrade>

</div>